export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
// export const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
export const PUBLIC_KEY = 'cGtfbGl2ZV9tUkRhTHFETDZHUWpzVVFCWERVSHNma2U6'; // LIVE
// export const PUBLIC_KEY = 'c2tfdGVzdF80UHR0QmtEQUZxaW0zR282a0E1aWVDUGQ6' //TODO: DEV Test data 
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
